// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Rubrics__Wrapper_66Wer","Items":"Rubrics__Items_UCFGN","Quarter":"Rubrics__Quarter_z-83h"};